import React, { useEffect, useState } from "react";

import { Button } from "@material-ui/core";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { AxlSearchBox, AxlFlex as Container } from "axl-reactjs-ui";
import { inject, observer } from "mobx-react";

// Components
import ListShipmentsByJob from "../../components/UploadComponents/ListShipmentsByJob";
import ShipmentUploadDetail from "../../components/UploadComponents/ShipmentUploadDetail";
import ShipmentUploadDetailPanel from "../../components/UploadComponents/ShipmentUploadDetailPanel";

// Styles
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import JobMapContainer from "../JobMapContainer";
import styles, * as E from "./styles";
import { colors } from "../../themes/colors";

const BatchDetail = ({ match, jobStore, isBlur, history }) => {
  const [shipmentFilter, setShipmentFilter] = useState("");

  const { params } = match;

  const onInlineFilter = (v) => {
    setShipmentFilter(v);
  }

  useEffect(() => {
    const delayFilter = setTimeout(() => {
      jobStore.shipmentFilter = shipmentFilter;
    }, 400);

    return (() => {
      clearTimeout(delayFilter);
    })
  }, [shipmentFilter])

  useEffect(() => {
    if (jobStore) {
      jobStore.shipmentFilter = null;
      if (params.id) {
        // try to parse to long first
        if (/^\d+$/.test(params.id)) {
          jobStore.getFinalizeJob(params.id, (job) => {
            jobStore.selectedJob = job;
            jobStore.getShipments();
          });
        } else {
          jobStore.getDraftJob(params.id, (job) => {
            if (jobStore.isProcessing(job.status)) {
              this.props.history.push("/batch");
            } else {
              jobStore.selectedJob = job;
              jobStore.getShipments();
            }
          });
        }
      }
    }
  }, []);

  const handleBackTo = () => {
    if(jobStore) {
      jobStore.selectedShipment = null;
    }
    history?.push("/batch");
  }

  return (
    <E.Contain>
      <E.Inner>
        <E.Head>
          <Button
            style={{color: colors.link}}
            onClick={handleBackTo}
            startIcon={<ArrowBackIosIcon />}
          >
            Back to Upload List
          </Button>
        </E.Head>
        <E.Main>
          <E.Section>
            <E.Panel>
              <AxlSearchBox
                theme={`default`}
                placeholder="Search Shipment"
                style={{ width: "100%" }}
                onChange={onInlineFilter}
              />
              <ShipmentUploadDetailPanel />
              <ListShipmentsByJob isBlur={isBlur} />
            </E.Panel>
          </E.Section>
          {jobStore?.selectedShipment && (
            <E.Section>
              <E.PanelDetail>
                <Switch>
                  <Route
                    path="/batch/:id/:shipmentId"
                    render={(props) => (
                      <ShipmentUploadDetail {...props} isBlur={isBlur} />
                    )}
                  />
                </Switch>
              </E.PanelDetail>
            </E.Section>
          )}
          <E.Section style={{ flex: jobStore?.selectedShipment ? 1 : 2 }}>
            <E.SectionMap>
              <JobMapContainer history={history} isBlur={isBlur} />
            </E.SectionMap>
          </E.Section>
        </E.Main>
      </E.Inner>
    </E.Contain>
  );
};

export default observer(inject("shipmentStore", "jobStore")(BatchDetail));
